export const pwa = {
  installApp: 'Install our app',
}
